/// <amd-module name="Test/TestPlansHubRefresh/KeyboardShortcutsModule/SuiteTreeKeyboardShortcutProvider" />
import { IVssKeyboardShortcutService } from "VSS/Platform/KeyboardShortcuts";
import { IVssPageContext, Services, VssService, IVssService } from "VSS/Platform/Context";
import { SuitesConstants, TelemetryConstants} from "Test/TestPlansHubRefresh/TestHub/Constants";
import { SuitesActions } from "Test/TestPlansHubRefresh/TestHub/Redux/Suites/SuitesActions"; 
import { TestHubRefreshConstants }  from "Test/TestPlansHubRefresh/TestHub/Constants";
import { TelemetryActions } from "Test/TestPlansHubRefresh/TestHub/Redux/TelemetryActions";
import { ISuitesMenu } from "Test/TestPlansHubRefresh/SuitesMenu/SuitesMenu.Types";
import { isAdvancedLicenseEnabled } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshSelector";

export interface ISuiteTreeKeyboardShortcutProvider extends IVssService {
    /**
     * Register keyboard shortcuts
     */
    registerKeyboardShortcuts(params: ISuitesMenu): void;
    /**
     * Unregisters a group of keyboard shortcuts
     */
    unregisterKeyboardShortcuts(): void;

}

export class SuiteTreeKeyboardShortcutProvider extends VssService implements ISuiteTreeKeyboardShortcutProvider {
    
    protected pageContext: IVssPageContext;

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this.pageContext = pageContext;
    }

    public _serviceRestart(pageContext: IVssPageContext): void {
        super._serviceRestart(pageContext);
    }
    
    public registerKeyboardShortcuts(params: ISuitesMenu) {
        const shortcutService = this.pageContext.getService<IVssKeyboardShortcutService>("IVssKeyboardShortcutService");
        shortcutService.registerShortcut(SuitesConstants.SUITE_TREE,{
            combos: ["f2"],
            description: TestHubRefreshConstants.RenameTestSuite,
            action: () => {
                this.renameTestSuite(params);
            }
        });
    }
    
    public renameTestSuite(params: ISuitesMenu) {
        if (params.suite.id) {
            params.dispatch(SuitesActions.editTestSuiteName(params.suite.id, params.suite.title));
            
            const telemetryPayload = {
                suiteId: params.suite.id,
                planId: params.planId,
                isAdvancedLicenseEnabled: isAdvancedLicenseEnabled
            };

            params.dispatch(TelemetryActions.publishTelemetry(TelemetryConstants.RENAME_TEST_SUITE_KEYBOARD, telemetryPayload));
        }

    }
    
    public unregisterKeyboardShortcuts() {
        const shortcutService = this.pageContext.getService<IVssKeyboardShortcutService>("IVssKeyboardShortcutService");
        shortcutService.removeShortcutGroup(SuitesConstants.SUITE_TREE);
    }
}
Services.add("SuiteTreeKeyboardShortcutProvider", { serviceFactory: SuiteTreeKeyboardShortcutProvider });
